import { useLocation } from 'react-router-dom'
import type { ReviewerContext } from '../schemas/sessionReviewers'
import { Link } from './nav'
import ScreenshotViewer from './ScreenshotViewer'

export function ReviewerArtifactLinks({ projectId, review }: { projectId: string; review: ReviewerContext }) {
  const location = useLocation()
  return <div className="session-reviewers__artifact-links">
    {review.journey_id && <p>Journey: <Link to={`/projects/${projectId}/journeys/${review.journey_id}`}>{review.journey_name || 'Reproduction journey'}</Link></p>}
    {review.bugs.length > 0 && <><h4>Filed bugs</h4><ul>{review.bugs.map(bug => <li key={`${bug.id}:${bug.is_duplicate}`}>
      <Link to={`/projects/${projectId}/bugs/${bug.id}`} state={{ bugListLocation: { pathname: location.pathname, search: location.search, hash: location.hash } }}>{bug.title}</Link>
      {' · '}{bug.status}{bug.is_duplicate && ' · Duplicate filing'}
    </li>)}</ul></>}
    {review.journey_id && review.bugs.length === 0 && <p>No bugs filed yet.</p>}
  </div>
}

export default function ReviewerReviewContext({ projectId, review }: { projectId: string; review: ReviewerContext }) {
  return <article className="session-reviewers__run">
    <h4>{review.user_email || 'Anonymous user'}</h4>
    <p><time dateTime={review.session_started_at}>{new Date(review.session_started_at).toLocaleString()}</time>{' · '}
      <a href={review.session_url} target="_blank" rel="noreferrer">View in FullStory</a></p>
    <h4>Review observations</h4>
    {review.output?.observations.map((observation, index) => <div key={index} className="session-reviewers__observation">
      <strong>{observation.code}</strong><p>{observation.description}</p>
      <dl>{Object.entries(observation.attributes).map(([key, value]) => <div key={key}><dt>{key}</dt><dd>{String(value)}</dd></div>)}</dl>
    </div>)}
    {!review.output && <p>Review output unavailable.</p>}
    {review.output?.observations.length === 0 && <p>No observations.</p>}
    {review.proposal && <><h4>Reproduction request</h4><p className="session-reviewers__review-copy">{review.proposal.instructions}</p><h4>Expected behavior</h4><p className="session-reviewers__review-copy">{review.proposal.expected_behavior}</p></>}
    {review.output?.screenshot && <figure className="session-reviewers__screenshot">
      <ScreenshotViewer frame={review.output.screenshot.image.url} alt={review.output.screenshot.caption} />
      <figcaption>{review.output.screenshot.caption}</figcaption>
    </figure>}
    <ReviewerArtifactLinks projectId={projectId} review={review} />
  </article>
}
